
async function LazyAxios() {
  const mod = await import('axios');
  return mod.default;
}
export default LazyAxios